export default __webpack_public_path__ + "static/media/kitchen5-beforeC-1024w.cb453f4f.png";